module.exports = __webpack_public_path__ + "img/bos.34b30f5a.png";